import { Search, TravelExploreOutlined } from '@mui/icons-material';
import { AdvancedButton, Buttons, MunicipalityButton } from './styles';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from '@/hooks/useTranslation';
import { SafeMarkdown } from '@/components/atoms/markdown/safe';

interface SearchButtonsProps {
  onMunicipalitySearch?: () => void;
  onAdvancedSearch?: () => void;
  height?: number | string;
  className?: string;
  zindex?: string;
  fullWidth?: boolean;
}

export const SearchButtons = ({
  onMunicipalitySearch,
  onAdvancedSearch,
  height,
  className,
  zindex,
  fullWidth,
}: SearchButtonsProps) => {
  const theme = useTheme();

  const { t } = useTranslation();

  return (
    <Buttons className={className} zindex={zindex}>
      <MunicipalityButton
        role="button"
        data-testid="quick-search-button"
        variant="contained"
        color="primary"
        onClick={onMunicipalitySearch}
        startIcon={<Search sx={{ color: theme.palette.text.primary }} />}
        height={height}
        fullWidth={fullWidth}
      >
        <SafeMarkdown text={t('button.button.quick_search')} />
      </MunicipalityButton>

      <AdvancedButton
        role="button"
        data-testid="advanced-search-button"
        variant="outlined"
        color="primary"
        onClick={onAdvancedSearch}
        startIcon={<TravelExploreOutlined sx={{ color: theme.palette.text.primary }} />}
        height={height}
        fullWidth={fullWidth}
      >
        <SafeMarkdown text={t('button.button.advanced_search')} />
      </AdvancedButton>
    </Buttons>
  );
};
